import { useMemo } from "react";
import {
  PlaceOfPerson,
  SYSTEM_PLACE_OF_PERSON_TYPE_LABELS,
} from "../../../types/placeOfPerson";
import { Person } from "../../../types/person";
import {
  SystemEntityCollections,
  SystemEntityProofreadingStatus,
} from "../../../shared/enums/shared-enums";
import { Place } from "../../../types/place";

const usePlaceOfPersonLogic = (from: Person | null, to: Place | null) => {
  const defaultPlaceOfPerson = useMemo<PlaceOfPerson>(
    () => ({
      _from: from?._id || "",
      _to: to?._id || "",
      _id: "",
      _key: "",
      _rev: "",
      system_place_of_person_type: null,
      fromDoc: from
        ? { ...from, _collection: SystemEntityCollections.PERSON }
        : null,
      toDoc: to ? { ...to, _collection: SystemEntityCollections.PLACE } : null,
      entity_status_of_proofreading:
        SystemEntityProofreadingStatus.NOT_PROOFREAD,
      internal_notes: "",
      notes: "",
      attributes_metadata: {},
    }),
    [from, to]
  );

  const getDisplayName = (connection: PlaceOfPerson) =>
    `${connection.system_place_of_person_type ? SYSTEM_PLACE_OF_PERSON_TYPE_LABELS[connection.system_place_of_person_type] : "Unknown"} Place of Person Relation`;

  return {
    defaultPlaceOfPerson,
    getDisplayName,
  };
};

export default usePlaceOfPersonLogic;
